import React, { useState, useEffect } from "react";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import Box from "@material-ui/core/Box";

import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { software } from "./constants";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "20px 0px 00px 00px",
    "& .MuiFormLabel-root": {
      color: theme.palette.checkbox.primary,
    }
  },
  title: {
    color: theme.palette.checkbox.primary,
    fontSize: theme.text.fontSize.tertiary,
  },
  checkbox: {
    color: theme.palette.checkbox.primary,
  }
}));

export default function CheckboxLabels() {
  const classes = useStyles();

  const [state, setState] = useState(software);

  const selector = useSelector(state => state.dataReducer);
  const dispatch = useDispatch();

  const languageMap = {
    r: 'R',
    m: 'Matlab',
    py: 'Python',
    sas: 'Sas',
    sol: 'Solidity',
    none: "None",
    cpp: "C++",
    sh: "Shell",
  }

  useEffect(() => {
    setState(selector.software)
  }, [selector])

  const handleChange = (event) => {
    // setState({ ...state, [languageMap[event.target.name]: event.target.checked });
    setState({ ...state, [languageMap[event.target.name]]: event.target.checked });
    // setState({ ...state, [event.target.name]: event.target.checked });
    dispatch({
      type: "FILTER_BY_SOFTWARE",
      payload: { name: [event.target.name], checked: event.target.checked },
    });
  };

  return (
    <Box className={classes.root}>
      <FormControl component="fieldset">
        <FormLabel component="legend" className={classes.title}>
         Programming Languages
         </FormLabel>
        <FormGroup column>
          {Object.entries(state).map(([key, value]) => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                    className={classes.checkbox}
                    icon={<CheckBoxOutlineBlankIcon />}
                    checkedIcon={<CheckBoxIcon />}
                    checked={value}
                    onChange={handleChange}
                    name={key}
                  />
                }
                label={languageMap[key]}
                key={key}
              />
            )
          })}
        </FormGroup>
      </FormControl>
    </Box>
  );
}
